import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Space Survey Functionalization Methodology',
    name: 'Space Survey Functionalization Methodology',
    partialId: PartialId.Standard.create('space_survey_funct_method'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
